<template>
  <b-notification
    type="is-warning"
    aria-close-label="Close notification"
    role="alert"
    v-if="showAddressWarning"
  >
    Por favor acesse a aba
    <router-link :to="'/configuracoes'"
      ><strong>Configurações</strong></router-link
    >
    e preencha o endereço que deve estar presente no boleto de pagamento.
  </b-notification>
</template>

<script>
import company from "../services/company";

export default {
  name: "AddressWarning",
  data() {
    return {
      showAddressWarning: false
    };
  },
  mounted() {
    this.getAddress();
  },
  methods: {
    async getAddress() {
      try {
        await company.getAddress();
        this.showAddressWarning = false;
      } catch (err) {
        const { response } = err;

        switch (response.status) {
          case 406:
            // user has no address for this city
            this.showAddressWarning = true;
            break;
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
